import { type FC, useEffect } from 'react';
import { useAiRovoCurrentRouteConfigurationStoreActions } from '@jira/ai-rovo_actions-store/src/aiRovoCurrentRouteConfigurationStore.tsx';
import { useCapacityRovoConfig } from '@jira/servicedesk__capacity/src/CapacityRovoConfigProviderEntry.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const AiRovoCapacityNudgesProvider: FC<{}> = (): null => {
	const { updateConfiguration } = useAiRovoCurrentRouteConfigurationStoreActions();
	const capacityConfig = useCapacityRovoConfig();

	useEffect(() => {
		if (!fg('jsm-workforce-skill')) {
			return;
		}

		updateConfiguration({
			// nudges to be added in a follow-up
			nudges: [],
			getActions: capacityConfig.getActions,
			tags: capacityConfig.tags,
		});
	}, [capacityConfig, updateConfiguration]);

	return null;
};
